export const organicLandingPagesValidator = (toParams): boolean => {
    const isValidState = isValidStateParams(toParams);
    return isValidState;
};

const isValidStateParams = ({ selectedDomain, key }) => {
    const selectedSites = key.split(",");
    return selectedDomain ? selectedSites.includes(selectedDomain) : true;
};
